import styled from 'styled-components'

/**
 *
 */
export const IconWrapper = styled.span`
  vertical-align: middle;
  text-align: center;
  margin: 0px 2px;
  padding-top: 2px;
`
